<template>
  <div>
    <b-card no-body class="p-0">
      <accordion
        v-for="(aba, i) in abas"
        :key="aba.titulo"
        :id="aba.xml"
        :title="aba.titulo"
        :disabled="aba.desabilitado() || !aba.componente"
        sub
        accordion="sub_aneel"
      >
        <template #append-title>
          <div v-if="aba.preenchido">
            <b-badge variant="success" class="ml-2">Preenchido</b-badge>
          </div>
        </template>

        <component
          :is="aba.componente"
          :projeto-editavel="projetoEditavel"
          :id-upload="`up${i}`"
          @salvar="
            salvarXML(
              $event,
              aba,
              aba.componente == 'comprovante-xml'
                ? 'Deseja salvar o comprovante?'
                : $event.mensagemConfirmacao
                ? $event.mensagemConfirmacao
                : 'Deseja gerar XML?',
              aba.componente == 'comprovante-xml'
                ? 'Comprovante salvo com sucesso'
                : 'XML gerado com sucesso'
            )
          "
          @deletar="
            deletarXML(
              $event,
              aba,
              false,
              aba.componente == 'comprovante-xml'
                ? 'Deseja excluir o comprovante?'
                : 'Deseja excluir o XML?',
              aba.componente == 'comprovante-xml'
                ? 'Comprovante excluído com sucesso'
                : 'XML excluído com sucesso'
            )
          "
          @deletar2="deletarXML($event, aba, true)"
          @download="download($event, aba)"
          @newDownload="downloadNew($event, aba)"
          @download2="download($event, aba, true)"
          :projeto="projeto"
          :ref="aba.xml"
          :itens="aba.objeto"
          :itens2="aba.objeto2"
        />
      </accordion>
    </b-card>
  </div>
</template>
<script>
import ProjetoGestaoService from "@/common/services/projeto_gestao/projeto_gestao.service";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import Accordion from "@/components/card/Accordion";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import helpers from "@/common/utils/helpers";

export default {
  mixins: [AlertasMixin],
  props: {
    projeto: {
      required: true,
    },
    projetoEditavel: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    "comprovante-xml": () => import("./componentes/AneelComprovante"),
    "aneel-1": () => import("./componentes/Aneel1_XMLProjeto.vue"),
    "aneel-3": () => import("./componentes/Aneel3_XMLInicio.vue"),
    "aneel-5": () => import("./componentes/Aneel5_XMLProrrogacao.vue"),
    "aneel-7": () => import("./componentes/Aneel7_RelatorioTecnicoFinal.vue"),
    "aneel-8": () =>
      import("./componentes/Aneel8_ComprovanteRelatorioTecnicoFinal.vue"),
    "aneel-9": () => import("./componentes/Aneel9_RelatorioAuditoria.vue"),
    "aneel-10": () =>
      import("./componentes/Aneel10_ComprovanteRelatorioAuditoria.vue"),
    "aneel-11": () => import("./componentes/Aneel11_ParecerAvaliacao.vue"),
    "aneel-12": () => import("./componentes/Aneel12_DefesaParecer.vue"),

    Accordion,
  },
  data: () => ({
    abas: [],
  }),

  methods: {
    criarAbas: function () {
      this.abas = [
        {
          titulo: "1 - XML do projeto",
          componente: "aneel-1",
          xml: "xml-projeto-gestao",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            return false;
          },
        },
        {
          titulo: "2 - Comprovante XML do projeto",
          componente: "comprovante-xml",
          xml: "comprovante-xml-projeto",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            return false;
          },
        },
        {
          titulo: "3 - XML de inicio",
          componente: "aneel-3",
          xml: "xml-inicio",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[1].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo: "4 - Comprovante XML de inicio",
          componente: "comprovante-xml",
          xml: "comprovante-xml-inicio",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[1].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo: "5 - XML de prorrogação",
          componente: "aneel-5",
          xml: "xml-prorrogacao",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[3].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo: "6 - Comprovante XML de prorrogação",
          componente: "comprovante-xml",
          xml: "comprovante-xml-prorrogacao",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[3].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo: "7 - Arquivos do relatório técnico final",
          componente: "aneel-7",
          xml: "xml-final",
          xml2: "relatorio-final-pdf",
          objeto: [],
          objeto2: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[3].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo: "8 - Comprovantes do relatório técnico final",
          componente: "aneel-8",
          xml: "comprovante-relatorio-final-xml",
          xml2: "comprovante-relatorio-final-pdf",
          objeto: [],
          objeto2: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[3].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo:
            "9 - Arquivos do relatório de auditoria contábil e financeiro",
          componente: "aneel-9",
          xml: "xml-auditoria",
          xml2: "relatorio-auditoria-pdf",
          objeto: [],
          objeto2: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[3].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo:
            "10 - Comprovantes do relatório de auditoria contábil e financeiro",
          componente: "aneel-10",
          xml: "comprovante-relatorio-auditoria-xml",
          xml2: "comprovante-relatorio-auditoria-pdf",
          objeto: [],
          objeto2: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[3].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo: "11 - Parecer de avaliação final ANEEL",
          componente: "aneel-11",
          xml: "avaliacao-final-aneel",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            let aba11 = this.abas[7].objeto;
            let aba13 = this.abas[9].objeto;
            return aba11.length == 0 || aba13.length == 0;
          },
        },
        {
          titulo: "12 - Defesa sobre parecer final",
          componente: "aneel-12",
          xml: "defesa-parecer-final",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[3].objeto;
            return aba.length == 0;
          },
        },
      ];

      this.buscarAbas(null);
    },

    buscarAbas: function (aba) {
      this.abas
        .filter((el) => {
          return el.xml && el.componente && (aba ? el.componente == aba : true);
        })
        .forEach((element) => {
          ProjetoGestaoService.listarXML(
            element.xml,
            !this.readonly ? this.projeto.id : this.projeto.projetoGestaoId
          ).then((response) => {
            element.objeto = response.data.data.itens;
            element.preenchido = element.objeto.length > 0;
          });
        });

      this.abas
        .filter((el) => {
          return (
            el.xml2 && el.componente && (aba ? el.componente == aba : true)
          );
        })
        .forEach((element) => {
          ProjetoGestaoService.listarXML(element.xml2, this.projeto.id).then(
            (response) => {
              element.objeto2 = response.data.data.itens;
            }
          );
        });
    },

    salvarXML: function (
      form,
      aba,
      mensagemConfirmacao = "Deseja gerar o XML?",
      mensagemSucesso = "XML gerado com sucesso!"
    ) {
      if (aba.xml2) {
        if (form.form2) {
          if (!this.$refs[aba.xml][0].validateState("form2-")) return;
        } else {
          if (!this.$refs[aba.xml][0].validateState("form1-")) return;
        }
      } else {
        if (!this.$refs[aba.xml][0].validateState()) return;
      }

      if (form.arquivoObrigatorio) {
        for (let index = 0; index < form.arquivoObrigatorio.length; index++) {
          if (!form[form.arquivoObrigatorio[index].campo]) {
            this.alertaErro(
              `Campo ${form.arquivoObrigatorio[index].nomeCampo} é obrigatório!`
            );
            return;
          }
        }
      }

      this.confirmar(
        !form.form2 ? mensagemConfirmacao : "Deseja salvar?",
        ""
      ).then((confirmado) => {
        if (confirmado) {
          form.projetoGestaoId = this.projeto.id;
          ProjetoGestaoService.salvarXML(form.form2 ? aba.xml2 : aba.xml, form)
            .then(() => {
              this.alertaSucesso(
                !form.form2 ? mensagemSucesso : "Salvo com sucesso"
              );
              this.buscarAbas(aba.componente);
              this.$emit("update");
            })
            .catch((err) => {
              if (err.response.status == 400) {
                this.alertaErro(err.response.data.errors);
              } else this.alertaErro("Erro ao salvar");
            });
        }
      });
    },

    deletarXML: function (
      id,
      aba,
      xml2 = false,
      mensagemConfirmacao = "Deseja deletar o XML?",
      mensagemSucesso = "XML deletado com sucesso!"
    ) {
      this.confirmar(!xml2 ? mensagemConfirmacao : "Deseja deletar?", "").then(
        (confirmado) => {
          if (confirmado) {
            ProjetoGestaoService.deletarXML(xml2 ? aba.xml2 : aba.xml, id)
              .then(() => {
                this.alertaSucesso(
                  !xml2 ? mensagemSucesso : "Deletado com sucesso"
                );
                this.buscarAbas(aba.componente);
              })
              .catch((err) => {
                if (err.response.status == 400) {
                  this.alertaErro(err.response.data.errors);
                } else this.alertaErro("Erro ao deletar");
              });
          }
        }
      );
    },

    download: function (nomeArquivo, arquivo) {
      let conteudobase64 = arquivo.objeto.sort(function (a, b) {
        return new Date(b.dataCriacao) - new Date(a.dataCriacao);
      })[0].conteudoBase64;
      let extensao = nomeArquivo.substring(nomeArquivo.lastIndexOf("."));
      var a = document.createElement("a"); //Create <a>
      if (
        conteudobase64 &&
        conteudobase64.includes("data:") &&
        conteudobase64.includes(";base64")
      )
        a.href = `${conteudobase64}`;
      else a.href = `data:application/${extensao};base64,${conteudobase64}`;

      a.download = nomeArquivo;
      a.click();
    },

    downloadNew: function (item, aba, xml2 = false) {
      this.$store.dispatch(START_LOADING);

      ProjetoGestaoService.downloadXML(xml2 ? aba.xml2 : aba.xml, item.id)
        .then((response) => {
          helpers.baixarArquivo(response.data, response.headers);
          this.alertaSucesso("Download do Arquivo Concluido!");
        })
        .catch((err) => {
          console.log(err);
          this.alertaErro("Erro ao fazer Download do Arquivo");
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    montar() {
      this.criarAbas();
    },
  },

  mounted: function () {
    this.criarAbas();
  },

  computed: {
    tela: function () {
      return this.$route.name;
    },
    readonly: function () {
      return this.$route.name != "projeto-gestao-proponente-detalhamento";
    },
  },
};
</script>
<style>
.aneel .nav-item {
  border-bottom: 1px solid #e5e5e5;
}
</style>
